import React, { useEffect, useState } from "react";
import styles from "./DocumentSection.module.css";
import clsx from "clsx";

interface DocumentSectionProps {
  content: string;
  isEditing?: boolean;
  onChange?: (updatedContent: string) => void;
  color: string;
  classNameStyle?: string;
}

const DocumentSection: React.FC<DocumentSectionProps> = ({
  content,
  isEditing = false,
  onChange = () => {},
  color,
  classNameStyle,
}) => {
  const [editedContent, setEditedContent] = useState(content);

  useEffect(() => {
    setEditedContent(content);
  }, [content]);

  const handleContentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newContent = event.target.value;
    setEditedContent(newContent);
    onChange(newContent);
  };

  return (
    <div className={clsx(styles["question-answer-container"], classNameStyle)}>
      <div className={styles["answer-block-container"]}>
        <div className={styles["inline-container"]}>
          {isEditing ? (
            <textarea
              value={editedContent}
              onChange={handleContentChange}
              className={clsx(styles["qc-textarea"], styles["qc-editing-mode"])}
              style={{ backgroundColor: color }}
            />
          ) : (
            <p className={styles["qc-text"]}>{editedContent}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentSection;